import { HubToHubApiRepository } from "@/app/infrastructures/repositories/api/HubToHubApiRepository";
import { injectable } from "tsyringe";

import { HubToHubRepositoryInterface } from "@/data/persistences/repositories/contracts/HubToHubRepositoryInterface";
import { GenerateInHubScanRequest } from "@/data/payload/api/HubToHubApiRequest";
import { InHubScanGenerateList, InHubScanTemporaryListRequest, HubInOutManifestEntities, HubInOutManifestRequest, ResponsePayload, HubInOutManifestExcelRequest, HubInOutManifestExcel, HubManifestTemporaryList } from "@/domain/entities/HubToHub";
import { postManifestRequestInterface } from "@/data/payload/contracts/HubToHubRequest";

@injectable()
export class HubToHubPresenter implements HubToHubRepositoryInterface {
  private repository: HubToHubApiRepository;

  constructor(repository: HubToHubApiRepository) {
    this.repository = repository;
  }

  public async generateInHubScan(
    payload: GenerateInHubScanRequest
  ): Promise<InHubScanGenerateList> {
    return this.repository.generateInHubScan(payload);
  }

  public async getListHubManifestTemporary(
    params: InHubScanTemporaryListRequest
  ): Promise<HubManifestTemporaryList> {
    return this.repository.getListHubManifestTemporary(params);
  }

    public async processHubManifest(payload: postManifestRequestInterface): Promise<ResponsePayload> {
    return this.repository.processHubManifest(payload);
    }
  getHubManifestDetail(id: number) {
    return this.repository.getHubManifestDetail(id);
  }
  
  public async getHubOutManifestList(
    params: HubInOutManifestRequest
  ): Promise<HubInOutManifestEntities> {
    return this.repository.getHubInOutManifestList(params);
  }
  
  public async getHubInManifestList(
    params: HubInOutManifestRequest
  ): Promise<HubInOutManifestEntities> {
    return this.repository.getHubInOutManifestList(params);
  }

  getHubManifestExcel(params: HubInOutManifestExcelRequest): Promise<HubInOutManifestExcel> {
    return this.repository.getHubManifestExcel(params);
  }
}
